import { api } from "./client";

export interface ActivityParams {
  page?: number;
  pageSize?: number;
  search?: string;
  actionType?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export function getActivity(params?: ActivityParams) {
  return api.get("/activity", { params });
}
